import React from 'react';
import { CheckCircle } from 'lucide-react';

/**
 * Minimal customer-facing payment success screen.
 *
 * Rules:
 * - No redirects
 * - No navigation to login or home
 * - Customer closes the tab when ready
 * - Can be rendered as a full page route or inline in the QR view
 */
const PaymentSuccessScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Pago completado correctamente.
          </h1>
          <p className="text-gray-600">
            Puedes cerrar esta página o volver al restaurante.
          </p>
          <p className="text-gray-600 mt-2">
            Gracias por usar YAP.
          </p>
        </div>

        <p className="text-gray-500 text-sm mt-4">
          Próximamente podrás descargar la app YAP para pagar aún más rápido.
        </p>
      </div>
    </div>
  );
};

export default PaymentSuccessScreen;
